<script>
import { mapGetters } from 'vuex';
import QuestionCloud from '../components/QuestionCloud';
import CloudFooter from '../components/CloudFooter';

export default {
    name: 'CloudPage',
    components: {
        QuestionCloud,
        CloudFooter,
    },
    data() {
        return {
            routerTransitionName: 'fade',
            lastScrollTop: 0,
            isScrolling: false,
            showFooter: true,
        }
    },
    mounted() {
        this.$store.dispatch('loadAllQuestions');
        this.$store.dispatch('loadAllQuestionCategories');

        this.$store.dispatch('setSiteHeaderTransparent');
        this.$store.dispatch('hideSiteFooter');

        window.addEventListener('scroll', this.onScroll);

    },
    methods: {
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // set header mode
            if (scrollTop > window.outerHeight) {
                this.$store.dispatch('setSiteHeaderOpaque');
            } else {
                this.$store.dispatch('setSiteHeaderTransparent');
            }

            // scroll to top
            if (this.getScrollDirection(scrollTop) === 'up' && scrollTop < window.outerHeight * .9 && !this.isScrolling) {
                // this.$scrollTo('#questionCloud', 750, { easing: [0.165, 0.84, 0.44, 1], onStart: () => { this.isScrolling = true; }, onDone: () => { this.isScrolling = false; } })
            }

            // hide footer if scrolled
            if (scrollTop > 3) {
                this.showFooter = false;
            } else {
                this.showFooter = true;
            }

            this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        },
        getScrollDirection(scrollTop) {
            let returnVal = scrollTop > this.lastScrollTop ? 'down' : 'up';
            
            return returnVal;
        }
    },
    computed: {
        ...mapGetters({
            selectedQuestion: 'getSelectedQuestion',
            isLoading: 'getQuestionsIsLoading',
        }),
    },
    watch: {
        selectedQuestion: function(val) {
            if (val) {
                this.$store.dispatch('showSiteFooter');
            } else {
                this.$store.dispatch('hideSiteFooter');
            }
        },
        isLoading: function(val) {
            if (!val && this.$route.params.slug) {
                this.$scrollTo(this.$refs.cloudRouterView, 950, { easing: [0.165, 0.84, 0.44, 1] });
            }
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.routerTransitionName = to.path.split('/').length !== from.path.split('/').length ? 'none' : 'fade';
        next();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll, false);
    }
};
</script>

<template>
    <section class="cloud-page">
        <question-cloud id="questionCloud" v-bind:style="{overflow: selectedQuestion ? 'visible' : 'hidden'}" />
        <transition v-bind:name="routerTransitionName" mode="out-in">
            <div ref="cloudRouterView">
                <router-view v-bind:key="this.$route.path" />
            </div>
        </transition>
        <transition name="footer-fade">
            <cloud-footer v-if="showFooter" />
        </transition>
    </section>
</template>

<style lang="scss" scoped>
.cloud-footer {
    position: fixed;
    left: 0; bottom: 0;
}

.fade-enter-active {
  transition: opacity 500ms;
}
.fade-leave-active {
  transition: opacity 200ms;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}

.footer-fade-enter-active ,
.footer-fade-leave-active {
  transition: opacity 200ms;
}
.footer-fade-enter,
.footer-fade-leave-to {
  opacity: 0;
}
</style>
